import { render, staticRenderFns } from "./SelectionRules.vue?vue&type=template&id=7536778f&scoped=true&"
import script from "./SelectionRules.vue?vue&type=script&lang=js&"
export * from "./SelectionRules.vue?vue&type=script&lang=js&"
import style0 from "./SelectionRules.vue?vue&type=style&index=0&id=7536778f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7536778f",
  null
  
)

export default component.exports